import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
  standalone: false,
  selector: 'app-patient-portal-check-in',
  templateUrl: './patient-portal-check-in.component.html',
  styleUrls: ['./patient-portal-check-in.component.css']
})
export class PatientPortalCheckInComponent implements OnInit {

  AppointmentId: string;
  PatientId: string;
  checkinQRCodeText: string;
  appointmentName: string;

  constructor(
    public dialogRef: MatDialogRef<PatientPortalCheckInComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.PatientId = this.data.PatientId;
    this.AppointmentId = this.data.AppointmentId;
    this.appointmentName = this.data.appointmentName;
    this.checkinQRCodeText = `${this.PatientId}/${this.AppointmentId}`;

  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
